import { combineReducers } from "redux";
import commonReducer from "./common.reducer";
import loginReducer from "./login.reducer";
import projectDetailsReducer from "./projectDetails.reducer";
import issueDetailsReducer from "./issueDetails.reducer";
import createProjectReducer from "./createProject.reducer";
import workflowReducer from "./workflow.reducer";
import momReducer from "./mom.reducer";
import userManagementReducer from "./userManagement.reducer";
import createAgendaReducer from "./createAgenda.reducer";
import misReducer from "./mis.reducer";
import dashboardReducer from "./dashboard-reducer";
import formReducer from "./form.reducer";
import addDecisionReducer from "./addDecision.reducer";
import issueActionReducer from "./issuesAction.reducer";
import notificationReducer from "./notification.reducer";
import { donwloadExcelReducer } from "./dowloadExcel.reducer";
import { projectListReducer } from "./projectList.reducer";
import { issueListReducer } from "./issueList.reducer";
import { userManualReducer } from "./userManual.reducer";
import { chartsReducer } from "./charts.reducer";
import pmgReducer from "./pmgReducer.reducer";
import pragatiReducer from "./pragati.reducer";

const reducer = combineReducers({
  commonReducer,
  loginReducer,
  projectDetailsReducer,
  issueDetailsReducer,
  createProjectReducer,
  workflowReducer,
  userManagementReducer,
  createAgendaReducer,
  misReducer,
  dashboardReducer,
  formReducer,
  addDecisionReducer,
  momReducer,
  issueActionReducer,
  notificationReducer,
  donwloadExcelReducer,
  projectListReducer,
  issueListReducer,
  userManualReducer,
  chartsReducer,
  pmgReducer,
  pragatiReducer
});

export default reducer;
